<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">申请人数</div>
            <div>
              <span class="num">{{spreadList.length}}</span
              >人
            </div>
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div>
      <div class="search acea-row row-between-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="点击搜索会员名称" v-model="screen.name" />
            <span class="iconfont icon-guanbi" @click="screen.name = ''"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2" @click="submitForm"></div>
      </div>
    </div>
    <div class="list">
      <div 
        class="sortList"
        v-if="spreadList.length > 0"
        >
        <div
          class="item acea-row row-between-wrapper"
          v-for="(item,index) in spreadList"
          :key="index"
          @click="goApplyDetail(item.id)"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="item.avatar" /></div>
            <div class="text">
              <div class="name line1">{{item.nickname}}</div>
              <div>姓名: {{item.name}}</div>
              <div>电话: {{item.phone}}</div>
              <div>等级: {{item.agent_range == 'city' ? '城市盟主' : '省代'}}</div>
            </div>
          </div>
          <div class="right">
            <div class="font-color">查看详情 ></div>
          </div>
        </div>
      </div>
      <div v-else>
        <img src="@assets/images/noThing.png" width="100%">
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadUser } from "../../../api/user";
import { getSpreadApplyLis } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "AgentApplicationList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 10,
        name:"",
        agent_range:""
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
      first: "",
      second: "",
      //
      
    };
  },
  mounted: function() {
    this.screen.agent_range = this.$route.query.type;
    this.getSpreadApplyLis();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSpreadApplyLis();
    });
  },
  watch: {
    "screen.sort": function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    }
  },
  methods: {
    goApplyDetail(id){
      this.$router.push({
        path : `/user/promotion/agent_application_detail?id=${id}`
      })
    },
    handleScroll: function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    submitForm: function() {
      this.screen.page = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadApplyLis();
    },
    
    getSpreadApplyLis: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getSpreadApplyLis(screen).then(
        res => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.data.data);
          that.loaded = res.data.data.length < that.screen.limit; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.page = that.screen.page + 1;
        },
        error => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function(val) {
      if(val == this.screen.agent)return;
      // if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        // this.screen.grade = val;
        this.screen.agent = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    
  }
};
</script>
<style scoped>
.promoter-list .list .sortList{
  margin-top: 0 !important;
}
.promoter-list .list .item{
  height: 2rem;
}
.font-color {
  color: #d2ac72!important;
}
</style>
